export default "__VITE_ASSET__Dx7Hr7eQ__"